
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';
import { QuestionCategoryType } from 'enums/QuestionCategoryType';
import { ReplyType } from 'enums/ReplyType';
import { CompanyModel } from './Entities.GormCrm.Company';
import { QuestionTagModel } from './Entities.GormCrm.QuestionTag';


export class QuestionnaireViewModel extends Model<QuestionnaireViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'questionCategories', type: 'QuestionCategoryViewModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionCategoryViewModel }, properties: () => { return QuestionCategoryViewModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public questionCategories: QuestionCategoryViewModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.questionCategories = [];
		
	}
	getProperties(){
		return QuestionnaireViewModel.classProperties;
	}
}
export class QuestionnaireQuestionReplyViewModel extends Model<QuestionnaireQuestionReplyViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionnaireId', type: 'string' },
		{ name: 'questionId', type: 'string' },
		{ name: 'required', type: 'boolean' },
		{ name: 'sortOrder', type: 'number' },
		{ name: 'questionnaireName', type: 'string' },
		{ name: 'category', type: 'QuestionCategoryType' },
		{ name: 'questionText', type: 'string' },
		{ name: 'questionReplyInputType', type: 'ReplyType' },
		{ name: 'requiredNumberOfReplies', type: 'number' },
		{ name: 'companyId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'productId', type: 'string' },
		{ name: 'productVariantId', type: 'string' },
		{ name: 'groupQuestions', type: 'boolean' },
		{ name: 'productName', type: 'string' },
		{ name: 'productTag', type: 'string' },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'variantName', type: 'string' }
	];
	[key: string]: any;
	
	public questionnaireId?: string;
	public questionId?: string;
	public required?: boolean;
	public sortOrder?: number;
	public questionnaireName: string;
	public category: QuestionCategoryType;
	public questionText: string;
	public questionReplyInputType?: ReplyType;
	public requiredNumberOfReplies: number;
	public companyId?: string;
	public orderId?: string;
	public taskflowId?: string;
	public productId?: string;
	public productVariantId?: string;
	public groupQuestions?: boolean;
	public productName: string;
	public productTag: string;
	public orderLineId?: string;
	public variantName: string;
    
	constructor(){
		super();
		this.questionnaireId = undefined;
		this.questionId = undefined;
		this.required = undefined;
		this.sortOrder = undefined;
		this.questionnaireName = '';
		this.category = 0;
		this.questionText = '';
		this.questionReplyInputType = undefined;
		this.requiredNumberOfReplies = 0;
		this.companyId = undefined;
		this.orderId = undefined;
		this.taskflowId = undefined;
		this.productId = undefined;
		this.productVariantId = undefined;
		this.groupQuestions = undefined;
		this.productName = '';
		this.productTag = '';
		this.orderLineId = undefined;
		this.variantName = '';
		
	}
	getProperties(){
		return QuestionnaireQuestionReplyViewModel.classProperties;
	}
}
export class QuestionCategoryViewModel extends Model<QuestionCategoryViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'categoryType', type: 'QuestionCategoryType' },
		{ name: 'questionGroups', type: 'QuestionGroupViewModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionGroupViewModel }, properties: () => { return QuestionGroupViewModel.classProperties } }
	];
	[key: string]: any;
	
	public categoryType: QuestionCategoryType;
	public questionGroups: QuestionGroupViewModel[];
    
	constructor(){
		super();
		this.categoryType = 0;
		this.questionGroups = [];
		
	}
	getProperties(){
		return QuestionCategoryViewModel.classProperties;
	}
}
export class QuestionGroupViewModel extends Model<QuestionGroupViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'companyId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'productId', type: 'string' },
		{ name: 'productVariantId', type: 'string' },
		{ name: 'groupQuestions', type: 'boolean' },
		{ name: 'productName', type: 'string' },
		{ name: 'productTags', type: 'string[]', isArray: true },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'variantName', type: 'string' },
		{ name: 'questions', type: 'QuestionViewModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionViewModel }, properties: () => { return QuestionViewModel.classProperties } },
		{ name: 'id', type: 'number', isHidden: true }
	];
	[key: string]: any;
	
	public company?: CompanyModel;
	public companyId?: string;
	public orderId?: string;
	public productId?: string;
	public productVariantId?: string;
	public groupQuestions: boolean;
	public productName: string;
	public productTags: string[];
	public orderLineId?: string;
	public taskflowId?: string;
	public variantName: string;
	public questions: QuestionViewModel[];
	public id: number;
    
	constructor(){
		super();
		this.company = undefined;
		this.companyId = undefined;
		this.orderId = undefined;
		this.productId = undefined;
		this.productVariantId = undefined;
		this.groupQuestions = false;
		this.productName = '';
		this.productTags = [];
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.variantName = '';
		this.questions = [];
		this.id = 0;
		
	}
	getProperties(){
		return QuestionGroupViewModel.classProperties;
	}
}
export class QuestionViewModel extends Model<QuestionViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionId', type: 'string' },
		{ name: 'required', type: 'boolean' },
		{ name: 'sortOrder', type: 'number' },
		{ name: 'questionCategory', type: 'QuestionCategoryType' },
		{ name: 'questionText', type: 'string' },
		{ name: 'questionReplyInputType', type: 'ReplyType' },
		{ name: 'requiredNumberOfReplies', type: 'number' },
		{ name: 'replyData', type: 'ReplyViewModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyViewModel }, properties: () => { return ReplyViewModel.classProperties } },
		{ name: 'questionTags', type: 'QuestionTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionTagModel }, properties: () => { return QuestionTagModel.classProperties } }
	];
	[key: string]: any;
	
	public questionId?: string;
	public required: boolean;
	public sortOrder?: number;
	public questionCategory: QuestionCategoryType;
	public questionText: string;
	public questionReplyInputType: ReplyType;
	public requiredNumberOfReplies: number;
	public replyData: ReplyViewModel[];
	public questionTags: QuestionTagModel[];
    
	constructor(){
		super();
		this.questionId = undefined;
		this.required = false;
		this.sortOrder = undefined;
		this.questionCategory = 0;
		this.questionText = '';
		this.questionReplyInputType = 0;
		this.requiredNumberOfReplies = 0;
		this.replyData = [];
		this.questionTags = [];
		
	}
	getProperties(){
		return QuestionViewModel.classProperties;
	}
}
export class ReplyViewModel extends Model<ReplyViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'replyId', type: 'string' },
		{ name: 'replies', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'taskflowId', type: 'string' }
	];
	[key: string]: any;
	
	public replyId?: string;
	public replies: string;
	public companyId?: string;
	public orderId?: string;
	public orderLineId?: string;
	public taskflowId?: string;
    
	constructor(){
		super();
		this.replyId = undefined;
		this.replies = '';
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		
	}
	getProperties(){
		return ReplyViewModel.classProperties;
	}
}

